define('SC.ThreadsThemeExtension.HeaderLogo', [
  'SC.ThreadsThemeExtension.LogoView'
], function HeaderSideBarLogoView(HeaderLogoView) {
  'use strict';
  return {
    loadModule: function loadModule(application) {
      var layout = application.getComponent('Layout');
      layout.addChildViews(layout.DEFAULT_VIEW, {
        'Header.SideBarLogo.View': {
          LogoView: {
            childViewIndex: 5,
            childViewConstructor: function childViewConstructor() {
              return new HeaderLogoView();
            }
          }
        }
      });
      layout.addChildViews(layout.DEFAULT_VIEW, {
        'Footer.Logo.View': {
          LogoView: {
            childViewIndex: 5,
            childViewConstructor: function childViewConstructor() {
              return new HeaderLogoView();
            }
          }
        }
      });
    }
  };
});
